import * as React from "react";
import { HBox, VBox } from "framework/structural_components/hbox_vbox";
import { Dialog, DialogContent, DialogTitle } from "framework/dialog/dialog";
import { Button } from "framework/controls/button";
import { Checkbox } from "framework/controls/checkbox";
import { useCookieConsent } from "./store";
import { cls_p5r, cls_p6r, cls_gap_form, cls_gap_half_rem, cls_colorGrey90 } from "style/index.css";
import { cls_content_box, cls_marker, cls_marker_box } from "./view.css";
import { useUIContext } from "common/uicontext/store";
import { cls_align_items_center, cls_align_items_flex_start } from "framework/structural_components/hbox_vbox.css";
import { useResponsivity } from "framework/responsivity/store";
import { useif } from "framework/state/types";
export var CookieConsentComponent = function () {
    var _a = useCookieConsent(), state = _a[0], actions = _a[1];
    var state_uicontext = useUIContext()[0];
    var state_resp = useResponsivity()[0];
    var T_HFM = state_resp.thresholdHeaderForMobile;
    React.useEffect(function () {
        if (state_uicontext.initialized) {
            if (state_uicontext.data.logged_user) {
                // logged user - load the data for given user and set it to the store, if consentGiven
                if (state_uicontext.data.cookie_consent.consentGiven) {
                    actions.setConsentData(state_uicontext.data.cookie_consent.cookieMeasurement, state_uicontext.data.cookie_consent.cookieMarketing, state_uicontext.data.cookie_consent.consentGiven, null);
                }
                else {
                    // logged user - try to load the data from local storage anyway
                    actions.loadFromLocalStorage();
                }
            }
            else {
                // anonymous user - load the data from local storage if available
                actions.loadFromLocalStorage();
            }
        }
    }, [state_uicontext.initialized]);
    React.useEffect(function () {
        if (state.initialized) {
            if (!state.consentGiven) {
                actions.openDialog();
            }
        }
    }, [state.initialized]);
    React.useEffect(function () {
        if (state_uicontext.data.logged_user && !state_uicontext.data.cookie_consent.consentGiven) {
            if (state.consentGiven && !state.consentSavedToCurrentAccount) {
                actions.saveToCurrentUserAccount();
            }
        }
    }, [state_uicontext.data.logged_user, state.consentGiven]);
    return React.createElement(Dialog, { open: state.showDialog },
        React.createElement(DialogContent, null,
            React.createElement(DialogTitle, null, "Nastavení cookies"),
            React.createElement(VBox, { className: [cls_gap_form, useif(T_HFM, cls_gap_half_rem), cls_align_items_flex_start, cls_p5r, useif(T_HFM, cls_p6r), cls_content_box] },
                React.createElement(HBox, { className: cls_gap_form },
                    React.createElement(VBox, { className: cls_gap_half_rem },
                        React.createElement(VBox, null,
                            React.createElement(HBox, null, "Na webu používáme během prohlížení následující cookies (propojení prohlížeče a internetových služeb):"),
                            React.createElement(HBox, { className: cls_gap_half_rem },
                                React.createElement(HBox, { className: [cls_marker_box, cls_align_items_center] },
                                    React.createElement(HBox, { className: cls_marker })),
                                React.createElement(HBox, null, "Technické, nezbytné pro funkci, například pro přihlášky.")),
                            React.createElement(HBox, { className: cls_gap_half_rem },
                                React.createElement(HBox, { className: [cls_marker_box, cls_align_items_center] },
                                    React.createElement(HBox, { className: cls_marker })),
                                React.createElement(HBox, null, "Analytické, užitečné pro statistiku návštěvnosti, od Google.")),
                            React.createElement(HBox, { className: cls_gap_half_rem },
                                React.createElement(HBox, { className: [cls_marker_box, cls_align_items_center] },
                                    React.createElement(HBox, { className: cls_marker })),
                                React.createElement(HBox, null, "Marketingové, užitečné pro sledování výsledků naší propagace, od Google. Reklamu, která není naše, nepoužíváme."))),
                        React.createElement(HBox, null, "Technické cookies jsou povolené vždy. Pro zapojení analytických a marketingových cookies nám můžete dát svůj souhlas:"))),
                React.createElement(HBox, null,
                    React.createElement(Checkbox, { name: "cookie_measurement", label: "Souhlasím s použitím analytických cookies.", state: state, actions: actions })),
                React.createElement(HBox, null,
                    React.createElement(Checkbox, { name: "cookie_marketing", label: "Souhlasím s použitím marketingových cookies.", state: state, actions: actions })),
                React.createElement(HBox, { className: [cls_gap_form, useif(T_HFM, cls_gap_half_rem)] },
                    React.createElement(HBox, null,
                        React.createElement(Button, { onClick: actions.agreeWithSelected }, 'Povolit vybrané')),
                    React.createElement(HBox, null,
                        React.createElement(Button, { onClick: actions.agreeWithAll }, 'Povolit všechny'))),
                React.createElement(HBox, { className: cls_colorGrey90 }, "Pokud se p\u0159ihl\u00E1s\u00EDte ke sv\u00E9mu \u00FA\u010Dtu, tyto souhlasy si zapamatujeme a budeme se jimi \u0159\u00EDdit i na jin\u00FDch za\u0159\u00EDzen\u00EDch, kde budete p\u0159ihl\u00E1\u0161eni."))));
};
